import novaSolicitacaoBeneficioRoutes from './novaSolicitacaoBeneficio/rotas.js';
const routes = [
    {
        path: 'pagamento-beneficios',
        name: 'ListagemPagamentoBeneficios',
        component: () => import('./ListagemPagamentoBeneficios.vue'),
        children: [
            { 
                path: 'detalhes/:id',
                name: 'DetalhesSolicitacaoBeneficio',
                component: () => import('./detalhesSolicitacao/DetalhesSolicitacoes.vue')
            },
            ...novaSolicitacaoBeneficioRoutes,
        ],
        meta: {
            rules: [''],
        },
    },
];

export default routes;